import {
  Box,
  Button,
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { PublishState, SearchInput } from '../../../components';
import { Plus } from '@phosphor-icons/react';
import { Link, useParams } from 'react-router';
import { Api } from '../../../api';
import { useModifiableParams } from '../../../hooks';

export default function PsychologyPromptsTab() {
  const { weekNumber, weekId } = useParams();

  const { getParams, setModifiedParams } = useModifiableParams();

  const params = getParams();

  const api = Api.PsychologyPrompt.useReadCollectionProgramWeekAsAdminSub(
    weekId ?? '',
    params,
  );

  const prompts = api.data?.member;
  return (
    <>
      <Stack direction="row" alignItems="end" spacing={2}>
        <SearchInput
          label="Search"
          value={params.title ?? ''}
          onChange={(e) => setModifiedParams({ title: e.target.value })}
          placeholder="Search by title"
        />
        <Box minWidth={185}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Plus />}
            component={Link}
            to={`/program/${weekNumber}/${weekId}/psychology-prompts/new`}
          >
            Create Prompt
          </Button>
        </Box>
      </Stack>
      <Card sx={{ mt: 2 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Position</TableCell>
                <TableCell>Publish State</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {prompts?.map((prompt) => (
                <TableRow
                  component={Link}
                  to={`/program/${weekNumber}/${weekId}/psychology-prompts/${prompt.id}`}
                  key={prompt.id}
                  sx={{
                    cursor: 'pointer',
                    textDecoration: 'none',
                    '&:hover': {
                      backgroundColor: 'action.hover',
                    },
                  }}
                >
                  <TableCell>{prompt.title}</TableCell>
                  <TableCell>{prompt.description}</TableCell>
                  <TableCell>{prompt.position}</TableCell>
                  <TableCell>
                    <PublishState
                      item={{
                        publishAt: prompt.publishedAt,
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </>
  );
}
